import { render, staticRenderFns } from "./HoldSAPForm.vue?vue&type=template&id=47854660&scoped=true&"
import script from "./HoldSAPForm.vue?vue&type=script&lang=ts&"
export * from "./HoldSAPForm.vue?vue&type=script&lang=ts&"
import style0 from "./HoldSAPForm.vue?vue&type=style&index=0&id=47854660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47854660",
  null
  
)

export default component.exports